<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/po">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Other Income Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_other_income
              }}</small>
            </div>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.create_dt
                        ? moment(
                            data.manifest.create_dt,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.manifest.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Recieve From</span>
                  <span class="m-list-desc">{{
                    data.manifest.recieve_from
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value</span>
                  <span class="m-list-desc">{{
                    data.manifest.currency
                      ? formatCurrency(
                          data.manifest.currency,
                          data.manifest.value
                        )
                      : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency</span>
                  <span class="m-list-desc">{{ data.manifest.currency }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{
                    data.manifest.description ? data.manifest.description : "-"
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-collapse class="margin-top" activeKey="1" v-if="isTaxOfficer">
            <a-collapse-panel key="0">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Tax Deposit Entry</h4>
                <a-button v-if="data.jenis == 'Verifikator' && isTaxOfficer" size="small" type="primary" icon="plus" class="margin-right" @click="(e)=>{handleCreateTaxDeposite(e,null)}">
                  Add
                </a-button>
              </div>

              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-config-provider :locale="getLocalConfigProvider()">
                <a-table
                  :rowKey="(record, index) => {return index;}"
                  :columns="columnsTaxDeposit"
                  :dataSource="datapajak.tax_deposit"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :scroll="{ x: 950 }"
                >
                  <span slot="no" slot-scope="text, data, index">
                    {{index+(pagination.page>1 ? ((pagination.page-1)*pagination.pageSize)+1 : 1)}}
                  </span>
                  <span slot="tax_date" slot-scope="item">
                    {{ item.tax_date ? moment(item.tax_date).format(getDefaultDateFormat) : "-" }}
                  </span>
                  <span slot="type_tax" slot-scope="item">
                    {{ item.label_type_tax }}
                  </span>
                  <span slot="tax_deposit" slot-scope="item">
                    {{ item.label_tax_deposite }}
                  </span>
                  <span slot="tax_object" slot-scope="item">
                    {{ item.label_tax_object }}
                  </span>
                  <span slot="value_dpp" slot-scope="item">
                    <CurrencyJustified
                      :currencyValue="'IDR'"
                      :valueNumber="item.value_dpp"
                    />
                  </span>
                  <span slot="value_tax" slot-scope="item">
                    <CurrencyJustified
                      :currencyValue="'IDR'"
                      :valueNumber="item.value_tax"
                    />
                  </span>
                  <span slot="actiondeposite" slot-scope="item">
                    <a-button-group>
                      <a-button
                        @click="(e)=>{handleCreateTaxDeposite(e,item)}"
                        icon="edit"
                        type="default"
                      ></a-button>
                      <a-button
                        @click="handleDeleteDeposit(item.id_dtl)"
                        icon="delete"
                        :loading="datapajak.deleteloading && datapajak.deleteloadingkey == item.id_dtl"
                        type="danger"
                      ></a-button>
                  </a-button-group>
                  </span>
                </a-table>
              </a-config-provider>
            </a-collapse-panel>
          </a-collapse>

          <a-card
            class="margin-top"
            :loading="loading.action"
            v-if="data.jenis === 'Verifikator' || data.jenis === 'Approve'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select
                  v-decorator="[
                    'aksi',
                    {
                      rules: [{ required: true }],
                      initialValue: data.aksi[0].aksi,
                    },
                  ]"
                >
                  <a-select-option
                    v-for="item in data.aksi"
                    :key="item.aksi"
                    >{{ item.aksi }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>

          <a-card
            class="margin-top"
            v-if="data.jenis === 'Transfer' && status_transfer && isKeuangan"
          >
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color: red !important"
                >(Funding has not been set)</i
              >
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="form">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="(dbt, index) in data.detailBuktiTransfer"
                  :key="index"
                >
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ dbt.tgl_tf }} | {{ dbt.user_tf }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                  <div class="m-display-flex space-between align-middle">
                    <p slot="description">
                      {{ dbt.currency + ". " + dbt.value_tf }}
                    </p>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.manifest.create_dt).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="data.manifest.description"
                      >{{ data.manifest.description }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleViews(item)">
                        {{ item.header }} | {{ item.tlc }}
                      </a>
                      <span v-if="item.no_manifest">
                        {{ item.no_manifest }}
                      </span>
                      <span
                        class="m-timeline-title"
                        v-if="
                          item.estimated_value && item.rest_api !== 'supplier'
                        "
                      >
                        {{
                          formatCurrency(item.currency, item.estimated_value)
                        }}
                      </span>
                    </div>
                    <div slot="description">
                      <Status
                        :color="item.doc_uploaded == 1 ? 'green' : 'red'"
                        :status="
                          item.doc_uploaded == 1
                            ? 'File has been uploaded'
                            : 'No file uploaded'
                        "
                      />
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                      <template v-if="item.tgl_mulai_dinas">
                        <span>
                          {{
                            moment(
                              item.tgl_mulai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}
                          -
                          {{
                            moment(
                              item.tgl_selesai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}
                        </span>
                      </template>
                    </div>
                  </a-list-item-meta>
                </a-list>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="visibleTaxDeposite" @ok="historyToggle" @cancel="handleTaxDepositeModalClose" :footer="null" :maskClosable="false" width="80%">
      <span slot="title"> <a-icon :type="datapajak.dataedit ? 'edit' : 'plus'" />&nbsp;{{datapajak.dataedit ? 'Edit' : 'Add'}} Data Tax Deposit Entry</span>

      <a-form :form="formTaxmodal">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Tax Date">
            <a-date-picker
              v-decorator="['tax_date', { rules: [{ required: true, message: 'please choose the date!' }], initialValue: datapajak.dataedit ? datapajak.dataedit.tax_date : null }]"
              placeholder="Select Date" format="DD-MM-YYYY" />
          </a-form-item>
          <a-form-item label="Tax Type">
            <a-select v-decorator="['tax_type', { rules: [{ required: true, message: 'please choose Tax Type!' }], initialValue: datapajak.dataedit ? datapajak.dataedit.type_tax : null }]"
            @change="changetaxType">
              <a-select-option v-for="item in getType_taxFiltered" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Tax Deposit">
            <a-select
              v-decorator="['kode_setoran_pajak', { rules: [{ required: true, message: 'please choose Tax Deposit!' }], initialValue: datapajak.dataedit ? datapajak.dataedit.id_setoran_pajak : null }]"
              option-filter-prop="children" :filter-option="filterOption" showSearch>
              <a-select-option v-for="item in datapajak.setoranpajak" :key="item.value" :value="item.value"
                :text="item.text">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Tax Object" v-if="!(datapajak.tax_type == 'pph_21' || datapajak.tax_type == 'ppn')">
              <a-select v-decorator="['objek_pajak', { rules: [{ required: false }], initialValue: datapajak.dataedit ? datapajak.dataedit.id_objek_pajak : null }]"
                option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                <a-select-option v-for="item in datapajak.objek_pajak" :key="item.value" :value="item.value" :text="item.text">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="DPP Value">
              <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'dpp_value',
                { rules: [{ required: true, validator: (datapajak.tax_type && datapajak.tax_type.toLowerCase() == 'pph_2529' ? checkpiReleaseValue : checkPrice) }], initialValue: datapajak.dataedit ? datapajak.dataedit.value_dpp : null },
              ]" />
            </a-form-item>
            <a-form-item label="Tax Value">
              <a-input-number type="number" class="m-width-full m-text-align-right"
                ref="taxvalue"
                v-on:keydown.enter.prevent="preventEnterButtontosave" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'value',
                {
                  rules: [{
                    required: true, validator: (datapajak.jenis_transaksi && datapajak.jenis_transaksi.toLowerCase() == 'pi' ? checkPriceTaxValue : (datapajak.jenis_transaksi && datapajak.jenis_transaksi.toLowerCase() == 'rilis_pi' && datapajak.tax_type && datapajak.tax_type!='pph_2529' ? checkpiReleaseValue: checkPrice))
                  }], initialValue: datapajak.dataedit ? datapajak.dataedit.value_tax : null
                },]" />
            </a-form-item>
            <div :style="this.hideUploadDocTax ? 'display:none' : ''">
              <a-form-item label="File Document Tax">
                <a-upload :fileList="filetaxDepositList" v-decorator="[
                  'file_document_tax',
                  { rules: [{ required: false, validator: doc_validation }] },
                ]" :remove="handleRemoveTaxdeposit" :beforeUpload="beforeUploadTaxdeposit">
                  <a-button>
                    <a-icon type="upload" />Select File
                  </a-button>
                </a-upload>
              </a-form-item>
            </div>
          </a-col>
        </a-row>
        <div>
          <div class="container-essential" v-if="modeedit && filetaxDepositList.length > 0">
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Date Document">
                  <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                    'tgl_document',
                    {
                      rules: [{ required: true }],
                      initialValue: datapajak.tax_doc.tgl_document ? moment(datapajak.tax_doc.tgl_document) : null,
                    },
                  ]" />
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Type Document">
                  <a-select v-decorator="['type_document', { rules: [{ required: true }], initialValue: datapajak.tax_doc.doc_type }]">
                    <a-select-option value="Bukti Potong Pajak">Bukti Potong Pajak</a-select-option>
                    <a-select-option value="Dokumen Faktur Pajak">Dokumen Faktur Pajak</a-select-option>
                    <a-select-option value="Dokumen STP">Dokumen STP</a-select-option>
                    <a-select-option value="Dokumen Id Billing">Dokumen Id Billing</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="No Document">
                  <a-input
                    v-decorator="['no_document', { rules: [{ required: true }], initialValue: datapajak.tax_doc.no_document }]"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </div>
        <a-button-group class="width-full">
          <a-button class="margin-top" @click="modalbuttonSavetaxDeposit" block type="primary" html-type="submit" :loading="datapajak.saveloading" ref="savetax"><b>Submit</b></a-button>
          <!-- <a-button v-if="data.jenis === 'Verifikator' && datapajak.tax_deposit.id_transaction" class="margin-top" @click="modalbuttonDeletetaxDeposit" block type="danger" html-type="submit" :loading="datapajak.deleteloading" ref="deletax"><b>Delete</b></a-button> -->
        </a-button-group>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "OtherIncomeManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    let doc_validation = (rule, value, callback) => {
      console.log()
      if (this.filetaxDepositList && this.filetaxDepositList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      notfound: { animationData: notfound, loop: true },
      previewVisible: false,
      previewImage: "",
      loading: false,
      visibleHistory: false,
      visibleLampiran: false,
      visiblePop: false,
      visibleShipmentStatus: false,
      visibleShipmentDeliver: false,
      visibleShipmentReceive: false,
      visibleShipmentReceiveManifest: false,
      visibleDpo: false,
      modalListDpo: [],
      fileListLampiran: [],
      fileListModalLampiran: [],
      fileList: [],
      fileListModal: [],
      reqFileTf: true,
      disableNilaiTf: true,
      data: {
        detail_pembelian: [],
        dokumen_terkait: [],
        detailBuktiTransfer: [],
        manifest: {},
        status: [],
        history: [],
        total: {
          subTotal: "",
          grandTotal: "",
          nilaiPajak: "",
        },
        dokumen_butuh: [],
        lampiran: [],
        jenis: "",
        aksi: [],
      },
      pagination: {
        page: 1,
        pageOri: 1,
        onChange: (page) => {
          this.pagination.page    = page;
          this.pagination.pageOri = page;
        },
        pageSize: 5,
        size: "small",
      },
      pajak: "",
      dateFormat: "DD MMMM YYYY",
      tlc: "",
      cek_value: 1,
      sisa_tf: "",
      temp_sisa_tf: "",
      temp_gudang_id: "",
      penerimaan: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 19 },
        },
      },
      currency: "",
      printLoad: {
        manifest: false,
        cancel: false,
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      status_shipment: [],
      dataShipmentDeliver: [],
      dataShipmentReceive: [],
      dataShipmentManifestDetail: [],
      dataShipmentManifestHeader: [],
      tempDataReceive: [],
      clickedPop: false,
      cacheData: {},
      btnShipment: {},
      dataDetailShipment: {},
      daftarGudang: {},
      checkTransferValue: true,
      allowEditModal: false,
      editGudangVal: undefined,
      usedfor: "gudang",
      editTlcVal: undefined,
      visibleEditDtl: false,
      enabledEditDtl: false,
      editReceiveDtl: {
        title: "",
        key: "",
        qty: 0,
        tlc: "",
        tlc_name: "",
        opsi: "gudangreceive",
        idgudang: "",
        gudang_name: "",
      },
      dtabel: [],
      dtemptabel: [],
      dlist: [],
      status_transfer: false,
      datapajak:{
        tax_deposit: {
          type_transaction: null,
          id_setoran_pajak: null,
          id_objek_pajak: null,
          value_dpp: null,
          value_tax: null
        },
        tax_doc:{
          tgl_document: null,
          type_document: null,
          no_document: null
        },
        jenis_transaksi: null,
        tax_type: null,
        setoranpajak: null,
        setoranpajakOri: null,
        objek_pajak: null,
        objek_pajakOri: null,
        saveloading: false,
        deleteloading: false,
        deleteloadingkey: "",
        dataedit: null,
      },
      modeedit: false,
      filetaxDepositList: [],
      doc_validation,
      hideUploadDocTax:true,
      search: "",
      visibleTaxDeposite: false,
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KURIR");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.$store.dispatch("Fetch_TYPE_TAX");
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
    this.formShipmentStatus = this.$form.createForm(this);
    this.formShipmentDeliver = this.$form.createForm(this);
    this.formDpo = this.$form.createForm(this);
    this.formShipmentReceive = this.$form.createForm(this);
    this.formSetReceive = this.$form.createForm(this);
    this.formeditRowDtl = this.$form.createForm(this);
    this.formTaxmodal = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getAllGudang",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStatusShipment",
      "getAllKurir",
      "getAllKaryawan",
      "getType_tax"
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_PN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          scopedSlots: { customRender: "unit_price" },
          width: 100,
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
      ];
      return kolom;
    },
    columnsTaxDeposit() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          align: "right",
          width: 50,
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Tax Date",
          key: "tax_date",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "tax_date" },
          sorter: (a, b) => a.tax_date - b.tax_date,
        },
        {
          title: "Type Tax",
          key: "type_tax",
          width: 150,
          scopedSlots: { customRender: "type_tax" },
          sorter: (a, b) => a.type_tax - b.type_tax,
        },
        {
          title: "Tax Deposit",
          key: "tax_deposit",
          width: 250,
          scopedSlots: { customRender: "tax_deposit" },
          sorter: (a, b) => a.tax_deposit - b.tax_deposit,
        },
        {
          title: "Tax Object",
          key: "tax_object",
          width: 250,
          scopedSlots: { customRender: "tax_object" },
          sorter: (a, b) => a.tax_deposit - b.tax_deposit,
        },
        {
          title: "Value DPP",
          key: "value_dpp",
          width: 200,
          scopedSlots: { customRender: "value_dpp" },
          sorter: (a, b) => a.value_dpp - b.value_dpp,
        },
        {
          title: "Value Tax",
          key: "value_tax",
          width: 200,
          scopedSlots: { customRender: "value_tax" },
          sorter: (a, b) => a.value_tax - b.value_tax,
        },
      ];

      if(this.data.jenis == 'Verifikator' && this.isTaxOfficer){
        kolom.push(
          {
            title: "Action",
            key: "actiondeposite",
            fixed: "right",
            align: "center",
            scopedSlots: { customRender: "actiondeposite" },
            width: 100,
          }
        )
      }
      return kolom;
    },
    searching() {
      if (this.search) {
        this.datapajak.tax_deposit = this.datapajak.tax_depositOri.filter(
          (obj) =>
            obj.tax_date && moment(obj.tax_date).format(this.getDefaultDateFormat).toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.label_type_tax && obj.label_type_tax.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.label_tax_deposite && obj.label_tax_deposite.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.label_tax_object && obj.label_tax_object.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
        this.pagination.page = 1
      }

      if (!this.search) {
        this.datapajak.tax_deposit = this.datapajak.tax_depositOri;
        this.pagination.page = this.pagination.pageOri
      }

      return this.datapajak.tax_deposit;
    },
    getLastStatusShipment() {
      if (this.status_shipment) {
        if (this.status_shipment.length !== 0) {
          if (
            this.status_shipment[this.status_shipment.length - 1].deli_sts ===
            "Received"
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getMainStatus() {
      if (this.data.status.length !== 0) {
        return this.data.status[this.data.status.length - 1].status;
      }
    },
    getShippingflag() {
      return this.data.shipping_flag;
    },
    isTaxOfficer(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Tax Officer");
      return data.length>0 ? true : false;
    },
    isKeuangan(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Keuangan");
      return data.length>0 ? true : false;
    },
    getType_taxFiltered(){
      return _.filter(this.getType_tax,(obj)=> obj.value!='bea_masuk')
    }
  },
  methods: {
    ...mapActions(["FETCH_ALL_KURIR"]),
    moment,
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "other_income",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            // ap: response.data.account_pay,
            currency: response.data.header[0].currency,
            manifest: response.data.header[0],
            // detail_pembelian: response.data.detail,
            // dokumen_butuh: response.data.document,
            status: response.data.status_app,
            //history: response.data.notifikasi,
            history: response.data.history,
            dokumen_terkait: response.data.dokumen_terkait,
            // lampiran: response.data.lampiran,
            jenis: response.data.jenis,
            aksi: response.data.aksi,
            detailBuktiTransfer: response.data.bukti_transfer,
            // purchasing: response.data.purchasing,
            last_status: response.data.last_status,
            // shipping_flag: response.data.shipping_flag,

            // revised_flag: response.data.header.revised_flag == "1" ? true : false,
          };
          // this.pajak = response.data.pajak;
          // this.tlc = this.getAuth.username;
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;
          // this.penerimaan = response.data.penerimaan;
          this.currency = response.data.header[0].currency;
          if (Number(this.sisa_tf) > 0) {
            this.status_transfer = true;
          } else {
            this.status_transfer = false;
          }

          let dbt = this.data.detailBuktiTransfer;
          for (const [i, val] of dbt.entries()) {
            let name = i + 1 + val.url.substring(val.url.lastIndexOf("."));
            this.data.detailBuktiTransfer[i]["fileList"] = [
              {
                url: process.env.VUE_APP_SERVICEURL + val.url,
                uid: i,
                name: name,
                status: "done",
              },
            ];
            // this.data.tgl_bukti_transfer.push(moment(val.tgl_tf).format(this.data.dateFormatTf));
          }

          if(response.data.tax_deposit.length>0){
            this.modeedit = true
          }
          if(response.data.tax_doc.length>0){
            this.datapajak.tax_doc       = response.data.tax_doc;

            let typefile = response.data.tax_doc.file_nm.substr(response.data.tax_doc.file_nm.lastIndexOf("."));

            if (typefile == ".xls") {
              typefile = "data:application/vnd.ms-excel;base64,";
            } else if (typefile == ".xlsx") {
              typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            } else if (typefile == ".doc") {
              typefile = "data:application/msword;base64,";
            } else if (typefile == ".docx") {
              typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            } else if (typefile == ".pdf") {
              typefile = "data:application/pdf;base64,";
            } else if (typefile == ".jpeg" || typefile == ".jpg") {
              typefile = "data:image/jpeg;base64,";
            } else if (typefile == ".png") {
              typefile = "data:image/png;base64,";
            }

            var file = this.dataURLtoFile(
              typefile + response.data.tax_doc.base64_file,
              response.data.tax_doc.file_nm
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.exist = true;
            file.url = this.$serviceUrl + "assets/upload/doc_tax/" + response.data.tax_doc.file_nm;
            this.filetaxDepositList = [file];
          }
          this.datapajak.tax_deposit     = response.data.tax_deposit;
          this.datapajak.tax_depositOri  = this.datapajak.tax_deposit;
          this.datapajak.setoranpajak    = response.data.setoran;
          this.datapajak.setoranpajakOri = this.datapajak.setoranpajak;
          this.datapajak.objek_pajak     = response.data.objek;
          this.renderTableDeposite()

          if(response.data.tax_deposit)
            this.datapajak.tax_type = response.data.tax_deposit.type_tax;

          // this.dtabel = [];
          // this.dtemptabel = [];
          // this.dlist = [];
          this.loading = false;
          // let tempdtl = response.data.detail;
          // for (let index = 0; index < tempdtl.length; index++) {
          //   const element = tempdtl[index];
          //   if (tempdtl[index].kategori == "0") {
          //     this.dtabel.push(element);
          //     this.dtemptabel.push(element);
          //   } else {
          //     this.dlist.push(element);
          //   }
          // }
        })
        .catch((err) => {
          if (!err.response) {
            // let responses = Object.assign({}, err.response.data);
            // this.displayMessageValue("error", responses);
            // this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },

    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },

    cancelLampiran() {
      this.fileListModalLampiran = [];
      this.formLampiran.resetFields();
    },

    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          this.formLampiran.return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "addendum/lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileListModal.push(file);
        } else {
          this.fileListModalLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },

    handlePreview(file) {
      if (file.url.substr(file.url.length - 3) === "pdf") {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },

    handleDownload(item) {
      // if (item.source === "simfoni") {
      window.open(this.$serviceUrl + item.link, "_blank");
      // } else {
      //   window.open(item.link, "_blank");
      // }
    },

    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },

    // metede template dari vue antd
    edit(key) {
      this.cacheData = this.tempDataReceive.map((item) => ({ ...item }));
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      this.editGudangVal = target.gudang_id;
      this.editTlcVal = target.tlc;

      if (target) {
        target.edit = true;
        target.editable = true;
        this.tempDataReceive = newData;
        // this.fullName = newData;
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.tempDataReceive = newData;
      }
    },
    handleSelected(value, key, column, index) {
      if (value === undefined) {
        const newData = [...this.tempDataReceive];
        const target = newData.filter((item) => key === item.key)[0];
        if (target) {
          // target[column] = dataFilter[0].gudang_nm;
          target["gudang_id"] = null;
          target["gudang_name"] = null;
          target["tlc"] = null;
          target["tlc_name"] = null;
          this.tempDataReceive = newData;
        }
      } else {
        if (this.usedfor === "gudang") {
          let dataFilter = this.getAllGudang.filter(
            (obj) =>
              obj.gudang_id.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].gudang_nm;
            target["gudang_id"] = value;
            this.tempDataReceive = newData;
          }
        } else {
          let dataFilter = this.getAllKaryawan.filter(
            (obj) => obj.tlc.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );

          const newData = [...this.tempDataReceive];
          const target = newData.filter((item) => key === item.key)[0];
          if (target) {
            target[column] = dataFilter[0].tlc_nm;
            target["tlc"] = value;
            this.tempDataReceive = newData;
          }
        }
      }
    },
    cancel(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        target.edit = false;
        this.tempDataReceive = newData;
      }
    },
    save(key) {
      const newData = [...this.tempDataReceive];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target.edit = false;
        delete target.editable;
        this.tempDataReceive = newData;
      }
    },
    getDataReceivePost(val) {
      this.tempDataReceive = val.map((item, index) => {
        return {
          key: item.id_dtl,
          no: index + 1,
          item_pn: item.item_pn,
          kd_anggaran: item.kode_anggaran,
          dtl_pp_nm: item.nama_dtl_pp,
          item_name: item.nama_barang,
          quantity: item.jumlah,
          satuan: item.satuan,
          gudang_name: null,
          gudang_id: null,
          tlc_name: null,
          tlc: null,
          edit: false,
        };
      });
    },

    openWindowCopy(link, noResi) {
      const me = this;
      this.$copyText(noResi).then(
        function (e) {
          // this.displayMessageValue("success-copy-resi",e.text);
          me.displayMessageValue("success-copy-resi", e.text);
          window.open(link, "_blank");
        },
        function (e) {
          alert("Can not copy");
        }
      );
    },
    handleSelectedStorage(val) {
      if (val !== undefined) {
        this.tempDataReceive.map((item) => {
          item.gudang_id = val.key;
          item.gudang_name = val.label;
        });
        this.allowEditModal = true;
        this.enabledEditDtl = true;
      } else {
        this.tempDataReceive.map((item) => {
          item.tlc = undefined;
          item.tlc_name = undefined;
          item.gudang_id = undefined;
          item.gudang_name = undefined;
        });
        this.allowEditModal = false;
        this.enabledEditDtl = false;
      }
    },

    handleViews(val) {
      if (val.rest_api === "supplier") {
        let namemanifest = null;
        if (this.getNavigation[0].divisi === "Akuntansi") {
          namemanifest = "SpclSupplierManifestAcc";
        } else {
          namemanifest = "manifestPurchasing";
        }
        this.$router.push({
          name: namemanifest,
          params: {
            id: val.id_manifest,
            tlc: this.getAuth.username,
            user_pembuat: val.user_pembuat,
          },
        });
      } else {
        this.handleView(val);
      }
    },

    handleEdit() {
      this.$router.push({
        name: "createPo",
        params: { id: this.id, type: "revised" },
      });
    },
    handleRemoveLampiran(item) {
      this.pageLoading = true;
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      Axios({
        method: "delete",
        url: serviceUrl + "addendum/lampiran",
        processData: false,
        data: {
          id_addendum_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          this.pageLoading = false;
          Event.$emit("refresh", true);
          this.displayMessage("success-del");
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }

          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("id_manifest", this.id);
          formData.append("remark", values.catatan);

          if (this.data.jenis === "Transfer") {
            formData.append("file_transfer", values.file_transfer.file);
            formData.append("status", "Transferred");
            formData.append(
              "tgl_tf",
              moment(values.tgl_tf).format(this.getStandartFormatDate)
            );

            // if (this.checkTransferValue) {
            //   //formData.append("cek_value", 1);
            //   formData.append("value_tf", 0);
            // } else {
            //ormData.append("cek_value", 0);
            formData.append("value_tf", values.value_transferan);
            //}
          }else{
            if (values.value_transferan < 1) {
              this.displayMessage("form-warning");
              return;
            }
            formData.append("status", values.aksi);
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "other_income/approval",
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
    },
    handleViewFile: function (item) {
      const data = {
        id_manifest: item.id_account_pay,
        rest_api: "accountpay",
      };
      this.handleView(data);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    checkPriceTaxValue(rule, value, callback) {
      if (value >= 0 && value != null) {
        callback();
        return;
      }
      callback("Value must equal or greater than zero!");
    },
    checkpiReleaseValue(rule, value, callback){
      if (value >= 0 && value != null) {
        callback();
        return;
      }
      callback("Value must equal or greater than zero!");
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function() {
        this.$refs.taxvalue.focus();
      });
    },
    preventEnterButtontosave() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function() {
        this.$refs.savetax.$children[0].$el.focus();
      });
    },
    modalbuttonSavetaxDeposit(){
      this.formTaxmodal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("tax_type", values.tax_type);
        data.append("jenis_transaksi", 'other_income');
        data.append("id_header", this.id);
        data.append("id_dtl", this.id);
        data.append("kode_setoran_pajak", values.kode_setoran_pajak);
        if (values.objek_pajak)
          data.append("objek_pajak", values.objek_pajak ? values.objek_pajak : null);
        data.append("value", values.value);
        data.append("tlc", this.getAuth.username);
        if (this.filetaxDepositList.length > 0)
          data.append("file_document_tax", this.filetaxDepositList[0]);
        data.append("dpp_value", values.dpp_value);

        if (this.modeedit && this.filetaxDepositList.length > 0) {
          data.append("tgl_document", moment(values.tgl_document).format(this.getStandartFormatDate));
          data.append("type_document", values.type_document);
          data.append("no_document", values.no_document);
        }

        if(this.datapajak.dataedit!=null){
          data.append("id_header", this.id);
          data.append("id_dtl", this.datapajak.dataedit.id_dtl);
        }

        data.append("tax_date", moment(values.tax_date).format(this.getStandartFormatDate));

        this.datapajak.saveloading = true;
        this.asyncAxiosPost("main/setoran_pajak", "formdata", this.getAuth, data)
          .then((response) => {
            this.datapajak.tax_deposit = response.tax_deposit
            this.datapajak.tax_depositOri = this.datapajak.tax_deposit
            this.handleTaxDepositeModalClose();
            this.renderTableDeposite()
            this.displayMessage("success-save");
            this.datapajak.saveloading = false;
            // this.cancel();
            // this.$router.go(0)
          })
          .catch((err) => {
            console.log(err);
            this.datapajak.saveloading = false;
          });
      });
    },
    handleDeleteDeposit(id_dtl){
      const that = this;
      this.$confirm({
        title: "Are you sure to Delete?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.datapajak.deleteloading = true;
          that.datapajak.deleteloadingkey = id_dtl;

          that.asyncAxiosDelete(
            "main/setoran_pajak",
            "application/json",
            that.getAuth,
            { "jenis_transaksi":"other_income",
              "id_header": that.id,
              "id_dtl": id_dtl
            }
          )
            .then((response) => {
              that.datapajak.deleteloading = false;

              that.datapajak.tax_deposit = response.tax_deposit
              that.datapajak.tax_depositOri = that.datapajak.tax_deposit
              that.pagination.page = 1
              that.pagination.pageOri = 1
              that.renderTableDeposite()

              if (response.status && response.status == true) {
                that.displayMessageValue("success-other", response.message);
              } else {
                let responses = Object.assign({}, response);
                that.displayMessageValue("error-other", responses);
              }
            })
            .catch((err) => {
              console.log(err);
              that.datapajak.deleteloading = false;
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error-other", responses.message);
            });
        },
        onCancel() { },
      });
    },
    changetaxType(val){
      this.datapajak.setoranpajak = _.filter(this.datapajak.setoranpajakOri,(obj)=> obj.id_type_tax == val);
      this.datapajak.tax_type = val;
      this.$nextTick(function () {
        this.formTaxmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
    },
    beforeUploadTaxdeposit(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.filetaxDepositList = [];
        this.filetaxDepositList.push(file);

        this.$nextTick(function () {
          this.formTaxmodal.setFieldsValue({
            type_document: null,
            no_document: null,
            tgl_document: null,
          });
        });
        return false;
      }
    },
    handleRemoveTaxdeposit() {
      this.filetaxDepositList = [];
    },
    handleCreateTaxDeposite(e, item){
      e.stopPropagation();
      this.visibleTaxDeposite = true
      if(item!=null){
        this.datapajak.dataedit = item
        this.datapajak.tax_type = item.type_tax
        this.datapajak.setoranpajak = _.filter(this.datapajak.setoranpajakOri,(obj)=> obj.id_type_tax == item.type_tax);
      }else{
        this.datapajak.dataedit = null
        this.datapajak.tax_type = null
        this.datapajak.setoranpajak = this.datapajak.setoranpajakOri
      }
    },
    handleTaxDepositeModalClose(){
      this.datapajak.dataedit = null;
      this.formTaxmodal.resetFields();
      this.visibleTaxDeposite = false
    },
    getLabelTax(val){
      let result = _.filter(this.getType_taxFiltered,(item) => item.value==val);
      return result.length>0 ? result[0].text : "";
    },
    getLabelDeposite(val){
      let result = _.filter(this.datapajak.setoranpajakOri,(item) => item.value==val);
      return result.length>0 ? result[0].text : "";
    },
    getLabelObject(val){
      let result = _.filter(this.datapajak.objek_pajak,(item) => item.value==val);
      return result.length>0 ? result[0].text : "";
    },
    renderTableDeposite(){
      this.datapajak.tax_deposit.forEach((item) => {
        item.label_type_tax     = this.getLabelTax(item.type_tax)
        item.label_tax_deposite = this.getLabelDeposite(item.id_setoran_pajak)
        item.label_tax_object = this.getLabelObject(item.id_objek_pajak)
      });
    }
  },
  mounted() {
    this.fetchManifest();
    // this.fetchShipment();
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageReturn", this.handleAction);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.reqFileTf = true;
        this.search = "";
      }
    },
  },
};
</script>

<style></style>
